import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  Opportunity, OpportunityCreateDTO, OpportunityStageChangeDTO,
  OpportunityBoard, OpportunityPage,
} from '../interfaces/crm/crm.interface';
import { Quotation } from '../interfaces/sales/quotation.interface';

export const OpportunityService = {
  board: async (institutionId: string): Promise<OpportunityBoard> =>
    (await axios.get(ENDPOINTS.CRM.OPPORTUNITY.BOARD_BY_INSTITUTION(institutionId))).data,
  listByInstitution: async (institutionId: string, page = 0, size = 10): Promise<OpportunityPage> =>
    (await axios.get(`${ENDPOINTS.CRM.OPPORTUNITY.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data,
  getById: async (id: string): Promise<Opportunity> =>
    (await axios.get(ENDPOINTS.CRM.OPPORTUNITY.GET_BY_ID(id))).data,
  create: async (dto: OpportunityCreateDTO): Promise<Opportunity> =>
    (await axios.post(ENDPOINTS.CRM.OPPORTUNITY.CREATE, dto)).data,
  update: async (id: string, dto: OpportunityCreateDTO): Promise<Opportunity> =>
    (await axios.put(ENDPOINTS.CRM.OPPORTUNITY.UPDATE(id), dto)).data,
  changeStage: async (id: string, dto: OpportunityStageChangeDTO): Promise<Opportunity> =>
    (await axios.patch(ENDPOINTS.CRM.OPPORTUNITY.CHANGE_STAGE(id), dto)).data,
  createQuotation: async (id: string): Promise<Quotation> =>
    (await axios.post(ENDPOINTS.CRM.OPPORTUNITY.CREATE_QUOTATION(id))).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.CRM.OPPORTUNITY.DELETE(id))).data,
};
